let devMode,
	mobileCheck,
	pageTransition,
	pageTransitionEnabled = false,
	resizeCallbacks = [],
	mapMaker,
	mobileResizeCallbacks = [],
	smoother;


function scriptMapLoaded(){
	window.dispatchEvent(new Event('scriptMapLoaded'));
}

document.addEventListener("DOMContentLoaded", function () {
	new StarterKitMcube();
	// Composants Mobile & Desktop
	new BannerSlider();
	new Gallery();
	new onScrollAnimations();
	new FooterAppear();
	new AppearOnScroll();
	// new MapMaker();
	// new Cursor();
	new Menu();

	if (mobileCheck.isMobile) {
		// Composants Mobile uniquement
	} else {

	}
});
